import React from 'react';
import { Segment, Form, Select, Input, Header } from 'semantic-ui-react';

// props:
// activityStatusTypes [] occupationStatuses [], removeActivityStatus fn,
export default class ActivityStatusForm extends React.PureComponent {
    render() {
        return (
            <div>
                <Form>
                    <Form.Field
                        required
                        control={Select}
                        label="Status u aktivnosti"
                        options={this.props.activityStatusTypes}
                        placeholder="Status u aktivnosti"
                        onChange={this.props.handleInputChange}
                        name="activityStatusType"
                        value={this.props.activityStatusType}
                        error={this.props.errorStatus}
                    />

                    <Form.Field
                        disabled={this.props.activityStatusType !== this.props.activeStatusId}
                        control={Input}
                        label="Zanimanje"
                        placeholder="Zanimanje"
                        value={this.props.occupation}
                        onChange={this.props.handleInputChange}
                        name="occupation"
                    />
                    <Form.Field
                        disabled={this.props.activityStatusType !== this.props.activeStatusId}
                        required
                        control={Select}
                        clearable
                        label="Status zanimanja"
                        options={this.props.occupationStatuses}
                        placeholder="Status zanimanja"
                        onChange={this.props.handleInputChange}
                        name="occupationStatus"
                        value={this.props.occupationStatus}
                    />

                    {/* <Button basic="true" color="red" onClick={this.props.removeActivityStatus}>Ukloni status</Button> */}
                </Form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentCreateAndEdit/FormParts/ActivityStatusForm.js